/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddComponentToSet } from '../../../../Components/AddComponentToSet/AddComponentToSet';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { COMPONENT_SET_DETAILS_DATA_IDS } from '../../ComponentSetDetails.constants';
import { ComponentSetDetailsComponentsProps } from './ComponentSetDetailsComponents.props';
import { ComponentsDetailedState } from './elements/ComponentsDetailedState/ComponentsDetailedState';
import { ComponentsEmptyState } from './elements/ComponentsEmptyState/ComponentsEmptyState';

/**
 * Component set details components.
 * @param {ComponentSetDetailsComponentsProps} props Component set details props.
 * @export
 * @returns {JSX.Element} The `<ComponentSetDetailsComponents />` component.
 */
export const ComponentSetDetailsComponents = (props: ComponentSetDetailsComponentsProps): JSX.Element => {
  const { t } = useTranslation();
  const { components, webPath, updateComponentSetDetails } = props;

  const labels = {
    addToSet: t(COMPONENT_SERVICE_STRINGS.addToSet),
    allComponents: t(COMPONENT_SERVICE_STRINGS.allComponentsInSet),
  };

  const isEmptyState: boolean = Object.keys(components).length === 0;

  return (
    <div className="component-set-details__components">
      <div className="component-set-details__components-header">
        <h2>{labels.allComponents}</h2>
        {!isEmptyState && (
          <div className="component-set-details__components-actions" data-id={COMPONENT_SET_DETAILS_DATA_IDS.actions}>
            <AddComponentToSet
              componentSetDisplayName={props.displayName}
              disabled={props.disabled}
              submitButtonText={labels.addToSet}
              updateComponentSetDetails={updateComponentSetDetails}
              webpath={webPath}
            />
          </div>
        )}
      </div>

      <div className={`component-set-details__components-container ${isEmptyState ? '--empty' : ''}`}>
        {isEmptyState ? <ComponentsEmptyState {...props} /> : <ComponentsDetailedState {...props} />}
      </div>
    </div>
  );
};
